import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from '@dcs-workspace/front-office/common';
import {
  MobileDocumentScanningComponent
} from "@dcs-workspace/shared";

const routes: Routes = [
  { path: 'forms', pathMatch: 'full', redirectTo: '' },
  { path: 'not-found', component: NotFoundComponent },
  { path: 'mobile-document-scanning', component: MobileDocumentScanningComponent },
  {
    path: 'home',
    loadChildren: () =>
      import('@dcs-workspace/front-office/home').then(
        (m) => m.FrontOfficeHomeModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('@dcs-workspace/front-office/forms').then(
        (m) => m.FrontOfficeFormsModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
